﻿import { setGeoData } from "./geoData";

const _chaveSessionUsuarioLogado = 'usuarioLogado';

export async function carregarUsuarioLogado() {

    const _mudarLayoutLogado = function (resposta) {

        const headerLogado = document.getElementById('header-candidato-logado');
        const menuLogadoOculto = document.getElementById('menu-logado-oculto');
        const outrosMenusNaoLogado = document.querySelector('.menu-nao-logado');

        //mostrar stick footer
        document.getElementById('stick-footer-candidato-logado').classList.remove("d-none");
        const footerEmpregare = document.getElementById('footer-empregare');
        if (document.contains(footerEmpregare)) {
            footerEmpregare.classList.add('mb-5', 'mb-md-0', 'pb-4', 'pb-md-0');
        }

        if (menuLogadoOculto !== null) {
            //mostrar menu logado
            document.getElementById('menu-logado-oculto').classList.remove("d-none");
        }

        if (outrosMenusNaoLogado !== null) {
            //esconder outro menu
            document.querySelector('.menu-nao-logado').classList.add('d-none');
        }

        // Mudancas para caso logar em hotsite
        const hotsite = document.querySelector("#layout-hotsite");

        if (hotsite) {
            let eventoLoginHostite = new CustomEvent("LoginHotsite");
            dispatchEvent(eventoLoginHostite);
        }

        const fotoCandidato = headerLogado.querySelectorAll(".img-perfil");
        fotoCandidato.forEach((item) => {
            item.src = resposta.foto;
        });

        const nomeCandidato = headerLogado.querySelectorAll(".header-nome-candidato");
        nomeCandidato.forEach((item) => {
            item.innerHTML = resposta.nome;
        });

        const numeroMensagens = document.querySelectorAll('.menu-mensagens-numero');
        numeroMensagens.forEach((item) => {            
            if (resposta.mensagens > 0) {
                item.innerHTML = resposta.mensagens;
                item.classList.remove('d-none');
            }
            
        });

        const numeroNotificacoes = document.querySelectorAll('.menu-noficacoes-numero');
        numeroNotificacoes.forEach((item) => {
            if (resposta.notificacoes > 0) {
                item.innerHTML = resposta.notificacoes;
                item.classList.remove('d-none');
            }
        });
    }

    const _fetchDados = async function () {
        await fetch(`/${CULTURE_EMPREGARE}/Login/GetUsuarioLogado`)
            .then(response => response.json())
            .then(async resposta => {
                sessionStorage.setItem(_chaveSessionUsuarioLogado, JSON.stringify(resposta));

                setGeoData(resposta.geoData);

                if (!resposta.logado) {
                    const { googleLogin } = await import('../componentes/googleLogin');
                    await googleLogin.init();
                    document.dispatchEvent(new CustomEvent('solicitarGoogleLoginOneTap'));
                    return;
                }
                _mudarLayoutLogado(resposta);                
            });
    };


    const sessionLogado = sessionStorage.getItem(_chaveSessionUsuarioLogado);

    if (!sessionLogado) {
        await _fetchDados();
        return;
    }

    const logadoJson = JSON.parse(sessionLogado);

    if (!logadoJson.logado) {
        const { googleLogin } = await import('../componentes/googleLogin');
        await googleLogin.init();
        document.dispatchEvent(new CustomEvent('solicitarGoogleLoginOneTap'));
        return;
    }
    _mudarLayoutLogado(logadoJson);
    
}

export function getUsuarioLogado() {
    const sessionLogado = sessionStorage.getItem(_chaveSessionUsuarioLogado);

    if (!sessionLogado) {
        return null;
    }

    return JSON.parse(sessionLogado);
}

export function removeCacheUsuarioLogado() {
    if (sessionStorage.getItem(_chaveSessionUsuarioLogado)) {
        sessionStorage.removeItem(_chaveSessionUsuarioLogado);
    }
}